import { CrudeConfiguration, JoinEntityLayout } from '@3m5/crude-frontend/dist/shared/types/configurationTypes'

import { crudeTheme } from '~shared/muiCrudeTheme'
import env from '~config/envConfig'
import { GetAuthorizationIdToken, GetXsrfToken } from '~utils/sessionStorage'
import { License } from '@3m5/crude-frontend/dist/shared/types/licenseTypes'

export const getCrudeConfiguration: () => CrudeConfiguration = () => {
  const config: CrudeConfiguration = {
    theme: crudeTheme,
    path: '/crude',
    api: {
      app: 'kundenportal',
      restPath: env.crudeBasePath + env.crudeRestPath,
      headers: [
        { name: 'X-XSRF-TOKEN', getHeader: GetXsrfToken },
        { name: 'Authorization', getHeader: GetAuthorizationIdToken },
      ],
    },
    tabs: [
      {
        entity: 'Company',
        hideEntity: false,
        tabs: [
          {
            sourceEntity: 'CompanyHasCompanyBusinessSegment',
            sourceColumn: 'companyId',
            hideEntity: true,
          },
        ],
      },
      {
        entity: 'CompanyBusinessSegment',
        hideEntity: true,
      },
    ],
    crudeLicense: {
      [License.outgoingReferenceFilters]: {
        available: false,
      },
      [License.standardFilter]: {
        available: true,
      },
      [License.extendedEditForms]: {
        available: true,
      },
      [License.i18n]: {
        available: true,
      },
      [License.extendedNavigation]: {
        available: true,
      },
      [License.richTextEditor]: {
        available: false,
      },
      [License.extendedTable]: {
        available: true,
      },
      [License.configurableTable]: {
        available: false,
      },
      [License.fileUpload]: {
        available: true,
      },
      [License.treeView]: {
        available: true,
      },
      [License.tooltips]: {
        available: true,
      },
      [License.freeJSON]: {
        available: true,
      },
      [License.integratedHTML]: {
        available: true,
      },
      [License.imageCropper]: {
        available: true,
      },
      [License.responsiveViews]: {
        available: false,
      },
    },
    editLayout: {
      version: 1,
      entities: [
        {
          entity: 'Company',
          elements: [
            {
              name: 'id',
              editTab: 'details',
              position: {
                horizontal: {
                  from: 0,
                  to: 0,
                },
                vertical: {
                  from: 0,
                  to: 0,
                },
              },
            },
            {
              name: 'name',
              editTab: 'details',
              position: {
                horizontal: {
                  from: 0,
                  to: 0,
                },
                vertical: {
                  from: 1,
                  to: 1,
                },
              },
            },
            {
              name: 'streetAndNumber',
              editTab: 'details',
              position: {
                horizontal: {
                  from: 0,
                  to: 0,
                },
                vertical: {
                  from: 2,
                  to: 2,
                },
              },
            },
            {
              name: 'zip',
              editTab: 'details',
              position: {
                horizontal: {
                  from: 0,
                  to: 0,
                },
                vertical: {
                  from: 3,
                  to: 3,
                },
              },
            },
            {
              name: 'city',
              editTab: 'details',
              position: {
                horizontal: {
                  from: 0,
                  to: 0,
                },
                vertical: {
                  from: 4,
                  to: 4,
                },
              },
            },
            {
              name: 'country',
              editTab: 'details',
              position: {
                horizontal: {
                  from: 0,
                  to: 0,
                },
                vertical: {
                  from: 5,
                  to: 5,
                },
              },
            },
            {
              name: 'phone',
              editTab: 'details',
              position: {
                horizontal: {
                  from: 0,
                  to: 0,
                },
                vertical: {
                  from: 6,
                  to: 6,
                },
              },
            },
            {
              name: 'crudeIncomingReference',
              layout: JoinEntityLayout.multiSelectDropdown,
              min: 1,
              sourceEntity: 'CompanyHasCompanyBusinessSegment',
              sourceColumn: 'companyId',
              editTab: 'details',
              position: {
                horizontal: {
                  from: 0,
                  to: 0,
                },
                vertical: {
                  from: 7,
                  to: 7,
                },
              },
            },

            {
              name: 'customerNumber',
              editTab: 'details',
              position: {
                horizontal: {
                  from: 1,
                  to: 1,
                },
                vertical: {
                  from: 0,
                  to: 0,
                },
              },
            },
            {
              name: 'vatId',
              editTab: 'details',
              position: {
                horizontal: {
                  from: 1,
                  to: 1,
                },
                vertical: {
                  from: 1,
                  to: 1,
                },
              },
            },
            {
              name: 'tecComId',
              editTab: 'details',
              position: {
                horizontal: {
                  from: 1,
                  to: 1,
                },
                vertical: {
                  from: 2,
                  to: 2,
                },
              },
            },
            {
              name: 'invoiceRecipientNumber',
              editTab: 'details',
              position: {
                horizontal: {
                  from: 1,
                  to: 1,
                },
                vertical: {
                  from: 3,
                  to: 3,
                },
              },
            },
            {
              name: 'goodsRecipientNumber',
              editTab: 'details',
              position: {
                horizontal: {
                  from: 1,
                  to: 1,
                },
                vertical: {
                  from: 4,
                  to: 4,
                },
              },
            },
            {
              name: 'supplierNumber',
              editTab: 'details',
              position: {
                horizontal: {
                  from: 1,
                  to: 1,
                },
                vertical: {
                  from: 5,
                  to: 5,
                },
              },
            },
            {
              name: 'grantAccessToPod',
              editTab: 'details',
              position: {
                horizontal: {
                  from: 1,
                  to: 1,
                },
                vertical: {
                  from: 6,
                  to: 6,
                },
              },
            },

          ],
          editTabs: [
            {
              title: {
                'de-DE': 'Details',
                'en-US': 'Details',
                'es-ES': 'detalles',
                'fr-FR': 'Détails',
                'it-IT': 'dettagli',
                'pl-PL': 'Detale',
                'pt-PT': 'detalhes',
                'ru-RU': 'Подробности',
                'tr-TR': 'detaylar',
              },
              name: 'details',
              formGroups: [
                {
                  name: 'contact',
                  initialOpen: true,
                  closable: false,
                  position: {
                    horizontal: {
                      from: 0,
                      to: 0,
                    },
                    vertical: {
                      from: 0,
                      to: 7,
                    },
                  },
                },
                {
                  name: 'information',
                  initialOpen: true,
                  closable: false,
                  position: {
                    horizontal: {
                      from: 1,
                      to: 1,
                    },
                    vertical: {
                      from: 0,
                      to: 7,
                    },
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    appLayout: {
      version: 1,
      elements: [],
      showStandardFilter: true,

      entityTemplates: [{
        name: 'CompanyHasCompanyBusinessSegment',
        template: 't({{data:type}})',
        onlyPositiveBooleans: false,
      }],
    },
  }
  return config
}
